export default __webpack_public_path__ + "static/media/snr.f27423f3.mp3";